import { render, staticRenderFns } from "./BombModule.vue?vue&type=template&id=68c496a0&scoped=true&"
import script from "./BombModule.vue?vue&type=script&lang=js&"
export * from "./BombModule.vue?vue&type=script&lang=js&"
import style0 from "./BombModule.vue?vue&type=style&index=0&id=68c496a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c496a0",
  null
  
)

export default component.exports